import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import env from '../../env.json';
import {store} from '../../App';

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: env.AZURE_APPINSIGHT_CONNECTION_STRING,
  },
});

export const trackInsightPageView = (screenName: any, params?: any) => {
  const userDetails: any = store?.getState()?.appState?.userInfo;

  appInsights.trackPageView({
    name: screenName,
    properties: {
      name: userDetails?.name,
      staffPositionId: userDetails?.staffPositionId,
      userId: userDetails?.userId,
      environment: `Admin ${env.ENVIRONMENT}`,
      ...params,
    },
  });
};

export const trackInsightEvent = (eventName: any, params?: any) => {
  const userDetails: any = store?.getState()?.appState?.userInfo;

  appInsights.trackEvent({
    name: eventName,
    properties: {
      name: userDetails?.name,
      staffPositionId: userDetails?.staffPositionId,
      userId: userDetails?.userId,
      environment: `Admin ${env.ENVIRONMENT}`,
      ...params,
    },
  });
};

export const trackInsightTrace = (message: any, params?: any) => {
  const userDetails: any = store?.getState()?.appState?.userInfo;

  appInsights.trackTrace({
    message: message,
    severityLevel: env.severityLevel ?? 1,
    properties: {
      name: userDetails?.name,
      staffPositionId: userDetails?.staffPositionId,
      userId: userDetails?.userId,
      environment: `Admin ${env.ENVIRONMENT}`,
      ...params,
    },
  });
};

export const trackInsightException = (error: any, params?: any) => {
  const userDetails: any = store?.getState()?.appState?.userInfo;

  appInsights.trackException({
    exception: error,
    properties: {
      name: userDetails?.name,
      staffPositionId: userDetails?.staffPositionId,
      userId: userDetails?.userId,
      environment: `Admin ${env.ENVIRONMENT}`,
      ...params,
    },
  });
};

export function generateUUID() {
  // Public Domain/MIT
  let d = new Date().getTime(); //Timestamp
  let d2 = 0; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
